export const myfs = "0.75em"

export const muiSelectTextfield_NonNative_fontSizeStyle = {
    fontSize:"1em",
    margin: "0em",
    "& .MuiFormLabel-root" : {fontSize:"1.1em",maxWidth:"calc( 133% - 2em )",transform:"translate(calc(2.0 * 0.875em), -0.5625em) scale(0.75)"},
    "& .MuiInputBase-root" : {fontSize:"1em",borderRadius:"0.25em",borderRadius: "9999px",padding:"0",
        "& .MuiSelect-select" : {paddingRight:"2em",borderRadius:"0.25em",padding:"1.0125em calc(2.0 * 0.875em)"},
        "& .MuiSvgIcon-root"  : {fontSize:"1.5em", right:"0.4375em"},
        "& .MuiOutlinedInput-notchedOutline" : { fontSize:"1em",top:"-0.3125em",padding:"0em calc(0.4em + (2.0 * 0.875em) - 0.875em)",borderWidth:"0.0625em",marginInlineStart:"0.125em",marginInlineEnd:"0.125em",
            "& legend":{fontSize:"0.9em",height:"0.6875em",paddingInlineStart:"0.125em",paddingInlineEnd:"0.125em",top:"-0.3125em",
                "& span":{fontSize:"1.0em",paddingLeft:"0.3125em",paddingRight:"0.3125em"}}}},
    "& .MuiFormHelperText-root" : {fontSize:"0.75em",margin:"0.1875em calc(2.0 * 0.875em) 0em calc(2.0 * 0.875em)"}
}
export const muiSelectTextfield_NonNative_fontSizeStyle_MaxWidthLegendVariant = {
    fontSize:"1em",
    margin: "0em",
    "& .MuiFormLabel-root" : {fontSize:"1.1em",maxWidth:"calc( 133% - 2em )",transform:"translate(calc(2.0 * 0.875em), -0.5625em) scale(0.75)"},
    "& .MuiInputBase-root" : {fontSize:"1em",borderRadius:"0.25em",borderRadius: "9999px",padding:"0",
        "& .MuiSelect-select" : {paddingRight:"2em",borderRadius:"0.25em",padding:"1.0125em calc(2.0 * 0.875em)"},
        "& .MuiSvgIcon-root"  : {fontSize:"1.5em", right:"0.4375em"},
        "& .MuiOutlinedInput-notchedOutline" : { fontSize:"1em",top:"-0.3125em",padding:"0em calc(0.4em + (2.0 * 0.875em) - 0.875em)",borderWidth:"0.0625em",marginInlineStart:"0.125em",marginInlineEnd:"0.125em",
            "& legend":{maxWidth:"100%!important",fontSize:"0.9em",height:"0.6875em",paddingInlineStart:"0.125em",paddingInlineEnd:"0.125em",top:"-0.3125em",
                "& span":{fontSize:"1.0em",paddingLeft:"0.3125em",paddingRight:"0.3125em"}}}},
    "& .MuiFormHelperText-root" : {fontSize:"0.75em",margin:"0.1875em calc(2.0 * 0.875em) 0em calc(2.0 * 0.875em)"}
}


export const muiTextfieldInputAdornment_NonNative_fontSizeStyle = {
    fontSize:"1em",
    margin: "0em",
    "& .MuiFormLabel-root" : {fontSize:"1.1em",maxWidth:"calc( 133% - 2em )",transform:"translate(calc(2.0 * 0.875em), -0.5625em) scale(0.75)"},
    "& .MuiInputBase-root" : {fontSize:"1em",borderRadius:"0.25em",borderRadius: "9999px",
        "& .MuiInputAdornment-root": {fontSize:"1em", marginRight:"0.5em",
            "& p": {fontSize:"1em"},
            "& svg": {fontSize:"2em"}},
        "& .MuiInputBase-input" : {paddingRight:"2em",borderRadius:"0.25em",padding:"1.0125em calc(2.0 * 0.875em)"},
        // "& .MuiSvgIcon-root"  : {fontSize:"1.5em", right:"0.4375em"},
        "& .MuiOutlinedInput-notchedOutline" : { fontSize:"1em",top:"-0.3125em",padding:"0em calc(0.4em + (2.0 * 0.875em) - 0.875em)",borderWidth:"0.0625em",marginInlineStart:"0.125em",marginInlineEnd:"0.125em",
            "& legend":{fontSize:"0.9em",height:"0.6875em",paddingInlineStart:"0.125em",paddingInlineEnd:"0.125em",top:"-0.3125em",
                "& span":{fontSize:"1.0em",paddingLeft:"0.3125em",paddingRight:"0.3125em"}}}},
    "& .MuiFormHelperText-root" : {fontSize:"0.75em",margin:"0.1875em calc(2.0 * 0.875em) 0em calc(2.0 * 0.875em)"}
}

export const muiTimePickerfield_NonNative_fontSizeStyle ={
    fontSize :"1em",
    margin: "0em",
    "& .MuiFormLabel-root" : {fontSize:"1.1em",maxWidth:"calc( 133% - 2em )",transform:"translate(calc(2.0 * 0.875em), -0.5625em) scale(0.75)",width:"100%"},
    "& .MuiInputBase-root" : {fontSize:"1em" ,borderRadius:"9999px",marginRight:"0.8em",
        "& .MuiInputBase-input" : {padding:"1.0125em calc(2.0 * 0.875em)", paddingRight:"0em",  },
        "& .MuiInputAdornment-root": {fontSize:"1em", marginRight:"0.5em",
            "& p": {fontSize:"1em"},
            "& svg": {fontSize:"1em"}},
        "& .MuiOutlinedInput-notchedOutline" : { fontSize:"1em",top:"-0.3125em",padding:"0em calc(0.4em + (2.0 * 0.875em) - 0.875em)",borderWidth:"0.0625em",marginInlineStart:"0.125em",marginInlineEnd:"0.125em",
        "& legend":{fontSize:"0.9em",height:"0.6875em",paddingInlineStart:"0.125em",paddingInlineEnd:"0.125em",top:"-0.3125em",
            "& span":{fontSize:"1.0em",paddingLeft:"0.3125em",paddingRight:"0.3125em"}}},
        },
    "& .MuiFormHelperText-root" : {fontSize:"0.75em",margin:"0.1875em calc(2.0 * 0.875em) 0em calc(2.0 * 0.875em)"}
}

export const muiOutlinedMultiline_NonNative_fontSizeStyle = {
    fontSize: "1em",padding:"1.03125em calc(2.0 * 0.875em)",borderRadius:"0.25em",margin:"0em",
    "& .MuiInputBase-input" : {fontSize:"1em"},
    "& .MuiOutlinedInput-notchedOutline" : { fontSize:"1em",top:"-0.3125em",padding:"0em calc(0.4em + (2.0 * 0.875em) - 0.875em)",borderWidth:"0.0625em",marginInlineStart:"0.125em",marginInlineEnd:"0.125em",
            "& legend":{fontSize:"0.9em",height:"0.6875em",paddingInlineStart:"0.125em",paddingInlineEnd:"0.125em",top:"-0.3125em", display:"none", // remove display:none if you want field label to work properly
                "& span":{paddingLeft:"0.3125em",paddingRight:"0.3125em"}}}
}

export const muiOutlinedInputfield_NonNative_fontSizeStyle = {
    fontSize:'1em',
    padding:"1.03125em calc(2.0 * 0.875em)"
}

export const muiCheckBox_NonNative_fontSizeStyle = {
    fontSize:"1.5em",
    padding: "0.5625em",
    "& .MuiSvgIcon-root" : {fontSize:"1em"}
}

export const muiCheckBox_NonNative_WithinSelectList_fontSizeStyle = {
    // Use for checkboxes within select menu
    fontSize:"1.5em",
    padding:"0.2em 0.5em",
    "& .MuiSvgIcon-root" : {fontSize:"1em"}
}

export const muiFormControlLabel_NonNative_WithinSelectList_fontSizeStyle = {
    // Use for checkboxes within select menu
    fontSize:"1em",
    marginBottom: "0em"
}

export const mui_MRT_TextfieldInput_fontSizeStyle = {
    // fontSize:"initial",
    margin: "0em",
    // "& .MuiFormLabel-root" : {fontSize:"1.1em",maxWidth:"calc( 133% - 2em )",transform:"translate(calc(2.0 * 0.875em), -0.5625em) scale(0.75)"},
    "& .MuiInputBase-root" : {fontSize:"1em",borderRadius: "9999px",paddingLeft:"calc(var(--cust-padding) + 0.4em)", paddingRight:"calc(var(--cust-padding) + 0.0em)",
        "& .MuiSvgIcon-root": {fontSize:"1em",},
        "& .MuiInputBase-input": {fontSize:"1em", padding: "0", paddingTop:"var(--cust-padding)",paddingBottom:"var(--cust-padding)"},
        "& .MuiButtonBase-root": {fontSize:"1em", padding:"0.27em"}
    }
}

export const boxStyle = {
    display:"flex",
    justifyContent:"center",
    alignContent: "center",
    justifyItems:"center",
    alignItems:"center"
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};